import React from 'react';
import './Payment.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered className='payment-modal'
        >
            <Modal.Header closeButton className='pb-0 payment-header'>
            </Modal.Header>
            <Modal.Body className='p-0'>
                <div className='person-name'>Robert Spaulding</div>
                <div className='credit-amt-block d-flex align-items-center gap-5 mt-4'>
                    <div className='amount'>Credit Amount:</div>
                    <div className='credit-block'>
                        $9.87
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide} className="orange-filled-btn closebtn">Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}

function Payment() {
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <div className="community-section">
            <div className="community-inner-wrap">
                <div className="add-new-community d-flex justify-content-between align-items-center">
                    <div className="community-heading">Payments & Credits</div>
                </div>
            </div>
            <div className="all-commmunities-table">
                <div className='billing-title allcommunities'>
                    Client Search
                </div>
                <div className='input-search mt-2'>
                    <input type="text" placeholder="Start Typing here..." />
                </div>
                <div className='payments-table'>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Type</th>
                                <th scope="col">Processed</th>
                                <th scope="col">Collected</th>
                                <th scope="col">Credit</th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            <tr>
                                <td >Robert</td>
                                <td>Realtor</td>
                                <td>2/2/2035</td>
                                <td>$9.76</td>
                                <td><div>
                                    <div className='credit-icon' onClick={() => setModalShow(true)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="20"
                                            height="20"
                                            x="0"
                                            y="0"
                                            viewBox="0 0 512 512"
                                            style={{ enableBackground: "new 0 0 512 512" }}
                                            xmlSpace="preserve"
                                            className=""
                                        >
                                            <g>
                                                <path
                                                    d="M52 512H15c-8.284 0-15-6.716-15-15V317c0-8.284 6.716-15 15-15h37c8.284 0 15 6.716 15 15v180c0 8.284-6.716 15-15 15zM493.252 348.812a36.199 36.199 0 0 0-36.828 1.132l-54.88 34.757c-1.659 14.16-7.893 27.299-18.05 37.7C371.15 435.039 354.639 442 337 442h-74.576c-8.077 0-15.027-6.207-15.407-14.275C246.611 419.111 253.475 412 262 412h75c19.579 0 35.456-16.162 34.99-35.845-.452-19.106-16.535-34.155-35.647-34.155H252l-9.784-7.338C222.731 320.048 198.587 312 174.23 312a113.345 113.345 0 0 0-58.298 16.147L97 339.507V492h252.126a75.002 75.002 0 0 0 41.044-12.227l105.439-68.941A36.096 36.096 0 0 0 512 380.529c0-13.2-7.184-25.353-18.748-31.717zM212 0C143.075 0 87 56.075 87 125s56.075 125 125 125 125-56.075 125-125S280.925 0 212 0zm15 187.071V190c0 8.284-6.716 15-15 15s-15-6.716-15-15v-2.942c-12.122-4.936-21.476-15.676-24.196-29.073-1.648-8.118 3.596-16.036 11.715-17.686 8.117-1.646 16.037 3.597 17.686 11.715.939 4.627 5.06 7.985 9.796 7.985 5.514 0 10-4.486 10-10s-4.486-10-10-10c-22.056 0-40-17.944-40-40 0-16.752 10.357-31.124 25-37.071V60c0-8.284 6.716-15 15-15s15 6.716 15 15v2.942c12.122 4.936 21.476 15.676 24.196 29.073 1.648 8.118-3.597 16.036-11.715 17.686-8.117 1.648-16.036-3.597-17.686-11.715-.94-4.628-5.06-7.986-9.796-7.986-5.514 0-10 4.486-10 10s4.486 10 10 10c22.056 0 40 17.944 40 40 0 16.752-10.357 31.124-25 37.071z"
                                                    fill="#ffffff"
                                                    opacity="1"
                                                    data-original="#ffffff"
                                                    className=""
                                                ></path>
                                                <path
                                                    d="M510.584 201.806A15 15 0 0 0 497 193.168h-21.834c-13.257-52.36-43.146-99.744-85.058-134.453-19.496-16.146-41.216-29.185-64.323-38.846C351.35 47.517 367 84.463 367 125c0 12.468-1.49 24.592-4.282 36.215 6.964 9.982 12.854 20.699 17.485 31.953H367a15 15 0 0 0-11.523 24.603l65 78a14.998 14.998 0 0 0 23.046 0l65-78a15 15 0 0 0 2.061-15.965z"
                                                    fill="#ffffff"
                                                    opacity="1"
                                                    data-original="#ffffff"
                                                    className=""
                                                ></path>
                                            </g>
                                        </svg>

                                    </div>
                                </div></td>
                            </tr>
                            <tr>
                                <td>Teddy</td>
                                <td>Ad Banner</td>
                                <td>2/2/2035</td>
                                <td>$9.76</td>
                                <td><div>
                                    <div className='credit-icon' onClick={() => setModalShow(true)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="20"
                                            height="20"
                                            x="0"
                                            y="0"
                                            viewBox="0 0 512 512"
                                            style={{ enableBackground: "new 0 0 512 512" }}
                                            xmlSpace="preserve"
                                            className=""
                                        >
                                            <g>
                                                <path
                                                    d="M52 512H15c-8.284 0-15-6.716-15-15V317c0-8.284 6.716-15 15-15h37c8.284 0 15 6.716 15 15v180c0 8.284-6.716 15-15 15zM493.252 348.812a36.199 36.199 0 0 0-36.828 1.132l-54.88 34.757c-1.659 14.16-7.893 27.299-18.05 37.7C371.15 435.039 354.639 442 337 442h-74.576c-8.077 0-15.027-6.207-15.407-14.275C246.611 419.111 253.475 412 262 412h75c19.579 0 35.456-16.162 34.99-35.845-.452-19.106-16.535-34.155-35.647-34.155H252l-9.784-7.338C222.731 320.048 198.587 312 174.23 312a113.345 113.345 0 0 0-58.298 16.147L97 339.507V492h252.126a75.002 75.002 0 0 0 41.044-12.227l105.439-68.941A36.096 36.096 0 0 0 512 380.529c0-13.2-7.184-25.353-18.748-31.717zM212 0C143.075 0 87 56.075 87 125s56.075 125 125 125 125-56.075 125-125S280.925 0 212 0zm15 187.071V190c0 8.284-6.716 15-15 15s-15-6.716-15-15v-2.942c-12.122-4.936-21.476-15.676-24.196-29.073-1.648-8.118 3.596-16.036 11.715-17.686 8.117-1.646 16.037 3.597 17.686 11.715.939 4.627 5.06 7.985 9.796 7.985 5.514 0 10-4.486 10-10s-4.486-10-10-10c-22.056 0-40-17.944-40-40 0-16.752 10.357-31.124 25-37.071V60c0-8.284 6.716-15 15-15s15 6.716 15 15v2.942c12.122 4.936 21.476 15.676 24.196 29.073 1.648 8.118-3.597 16.036-11.715 17.686-8.117 1.648-16.036-3.597-17.686-11.715-.94-4.628-5.06-7.986-9.796-7.986-5.514 0-10 4.486-10 10s4.486 10 10 10c22.056 0 40 17.944 40 40 0 16.752-10.357 31.124-25 37.071z"
                                                    fill="#ffffff"
                                                    opacity="1"
                                                    data-original="#ffffff"
                                                    className=""
                                                ></path>
                                                <path
                                                    d="M510.584 201.806A15 15 0 0 0 497 193.168h-21.834c-13.257-52.36-43.146-99.744-85.058-134.453-19.496-16.146-41.216-29.185-64.323-38.846C351.35 47.517 367 84.463 367 125c0 12.468-1.49 24.592-4.282 36.215 6.964 9.982 12.854 20.699 17.485 31.953H367a15 15 0 0 0-11.523 24.603l65 78a14.998 14.998 0 0 0 23.046 0l65-78a15 15 0 0 0 2.061-15.965z"
                                                    fill="#ffffff"
                                                    opacity="1"
                                                    data-original="#ffffff"
                                                    className=""
                                                ></path>
                                            </g>
                                        </svg>

                                    </div>
                                    <MyVerticallyCenteredModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                    />
                                </div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Payment;